import type { ClientMilestone } from '@/types/milestone-ratings';

/** What the milestone row offers: rate it now, show the rating given, or nothing yet (not delivered). */
export type MilestoneRatingState = 'rate' | 'rated' | 'upcoming';

export const milestoneRatingState = (milestone: Pick<ClientMilestone, 'can_rate' | 'my_rating'>): MilestoneRatingState =>
  milestone.my_rating ? 'rated' : milestone.can_rate ? 'rate' : 'upcoming';

export const MAX_RATING_COMMENT = 1000;

/** A rating is 1–5 whole stars. */
export const isValidRating = (value: unknown): value is number =>
  typeof value === 'number' && Number.isInteger(value) && value >= 1 && value <= 5;
